module.exports = __webpack_public_path__ + "img/langston-league.e94b4f99.png";